import { GroupMessages } from '@/routes/messages/groups/by-id';
import { SessionMessages } from '@/routes/messages/sessions/by-id';
import { useLayoutStore } from '@/stores/layout-status';
import { parseSessionKey } from '@/utils/session';

export default function DesktopRightSection() {
  const { sessionKey } = useLayoutStore();

  if (sessionKey) {
    const [type, id] = parseSessionKey(sessionKey);
    return type === 'session' ? <SessionMessages sessionId={id} /> : <GroupMessages groupId={id} />;
  }

  return null;
}
